__webpack_require__.p = "/ui-use-cdk/referrals-hub/";